import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RekbotsService } from '../../services/rekbots.service';

@Component({
  selector: 'app-modal-rekbot-details',
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './modal-rekbot-details.component.html',
  styleUrl: './modal-rekbot-details.component.css'
})
export class ModalRekbotDetailsComponent implements OnInit {

  constructor(
      public rekbotsService: RekbotsService,
  ) { }

  ngOnInit(): void {
    console.log('ModalRekbotDetailsComponent initialized');
  }


}
